import { render, staticRenderFns } from "./LayoutScreen.vue?vue&type=template&id=a7f21b34&scoped=true"
import script from "./LayoutScreen.vue?vue&type=script&lang=js"
export * from "./LayoutScreen.vue?vue&type=script&lang=js"
import style0 from "./LayoutScreen.vue?vue&type=style&index=0&id=a7f21b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f21b34",
  null
  
)

export default component.exports